import { i18n } from '@/i18n'

export default [
  {
    path: 'companies',
    name: 'companies',
    component: () => import('@/views/companies/Companies.vue'),
    meta: { registerNavFromMenu: true, title: i18n.t('app.companies') }
  },
  {
    path: 'companies/:id/details',
    name: 'companies/detail',
    component: () => import('@/views/companies/Company.vue'),
    meta: { secondaryMenu: 'companies', registerNavFromMenu: false, title: i18n.t('app.company_detail') }
  },
  {
    path: 'companies/:id/locations',
    name: 'companies/locations',
    component: () => import('@/views/companies/Locations.vue'),
    meta: { secondaryMenu: 'companies', registerNavFromMenu: false, title: i18n.t('app.locations_link') }
  },
  {
    path: 'companies/:id/details/locations/:location_id',
    name: 'companies/locations/detail',
    component: () => import('@/views/companies/Location.vue'),
    meta: { secondaryMenu: 'companies', registerNavFromMenu: false, title: i18n.t('app.location') }
  },
  {
    path: 'companies/:id/certificates',
    name: 'companies/certificates',
    component: () => import('@/views/companies/Certificates.vue'),
    meta: { secondaryMenu: 'companies', registerNavFromMenu: false, title: i18n.t('app.other_certificates') }
  },
  {
    path: 'companies/:id/courtesydaysaeat',
    name: 'companies/courtesydaysaeat',
    component: () => import('@/views/companies/CourtesyDaysAEAT.vue'),
    meta: { secondaryMenu: 'companies', registerNavFromMenu: false, title: i18n.t('companies.courtesy_days_aeat') }
  },
  {
    path: 'companies/:id/hotfolder',
    name: 'companies/hotfolder',
    component: () => import('@/views/companies/HotFolder.vue'),
    meta: { secondaryMenu: 'companies', registerNavFromMenu: false, title: i18n.t('hotfolder.title') }
  },
  {
    path: 'companies/:id/historical',
    name: 'companies/historical',
    component: () => import('@/views/historical/CompanyHistorical.vue'),
    meta: { secondaryMenu: 'companies', registerNavFromMenu: false, title: i18n.t('historical.by_company') }
  }
]
